"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.businessLeaderboardIds = exports.memberLeaderboardIds = exports.sparklyLeaderboardIds = exports.mtpBadge = exports.leaderboardBadges = exports.carbonReductionBadges = exports.sparklyBadges = exports.treeBadges = exports.climatePositiveBadges = exports.availableBadges = exports.BadgeCategory = void 0;
var BadgeCategory;
(function (BadgeCategory) {
    BadgeCategory["ClimatePositive"] = "climate-positive";
    BadgeCategory["TreesPlanted"] = "trees-planted";
    BadgeCategory["SparklyTrees"] = "sparkly-trees";
    BadgeCategory["CarbonReduction"] = "carbon-reduction";
    BadgeCategory["Leaderboard"] = "leaderboard-badge";
    BadgeCategory["Mta"] = "mta-badge";
})(BadgeCategory = exports.BadgeCategory || (exports.BadgeCategory = {}));
exports.availableBadges = {
    mtpBadge: {
        id: 'mtpBadge',
        title: 'Million Tree Pledger',
        visibility: 'mta-only',
        total: 0,
        standoutTotal: '0',
        copy: "You committed to planting over 1 million trees in response to the Climate Emergency. We're proud to be supporting you on this journey and think you're pretty awesome!",
        category: BadgeCategory.Mta,
    },
    leaderboardTop100Sparkly: {
        id: 'leaderboardTop100Sparkly',
        title: 'Top 100 sparkly tree leaderboard',
        visibility: 'all',
        total: 0,
        standoutTotal: 'Top 100',
        copy: "You're the shiniest of the shiny! You've made it into our top 100 sparkly tree leaderboard, so here's a new shiny badge to match it.",
        category: BadgeCategory.Leaderboard,
    },
    leaderboardTop100Member: {
        id: 'leaderboardTop100Member',
        title: 'Top 100 member tree leaderboard',
        visibility: 'member-only',
        total: 0,
        standoutTotal: 'Top 100',
        copy: "Look at your speeding ahead! You've made it into our top 100 members leaderboard. Go on shout it from the rooftops.",
        category: BadgeCategory.Leaderboard,
    },
    leaderboardTop100Business: {
        id: 'leaderboardTop100Business',
        title: 'Top 100 business tree leaderboard',
        visibility: 'business-only',
        total: 0,
        standoutTotal: 'Top 100',
        copy: 'Pop a bottle because you and your company have made it into our top 100 business leaderboard. This is a huge achievement, make sure to share it with your team.',
        category: BadgeCategory.Leaderboard,
    },
    trees100: {
        id: 'trees100',
        title: '100 trees funded',
        visibility: 'all',
        total: 100,
        standoutTotal: '100',
        copy: "Look at that, you've funded 100 trees! You're well on your way to your own little forest.",
        category: BadgeCategory.TreesPlanted,
    },
    trees500: {
        id: 'trees500',
        title: '500 trees funded',
        visibility: 'all',
        total: 500,
        standoutTotal: '500',
        copy: "Look at how you've grown! By this point your forest will be full of life and helping to repair our planet.",
        category: BadgeCategory.TreesPlanted,
    },
    trees1000: {
        id: 'trees1000',
        title: '1,000 trees funded',
        visibility: 'all',
        total: 1000,
        standoutTotal: '1K',
        copy: "Woah, that's a lot of trees! Consider yourself a tree champion because we sure do.",
        category: BadgeCategory.TreesPlanted,
    },
    trees5000: {
        id: 'trees5000',
        title: '5,000 trees funded',
        visibility: 'all',
        total: 5000,
        standoutTotal: '5K',
        copy: "Stop everything you're doing, you've funded over 5,000 trees. This. Is. Epic. Just think, by now your forest will be the home to lots of critters large and small.",
        category: BadgeCategory.TreesPlanted,
    },
    trees10000: {
        id: 'trees10000',
        title: '10,000 trees funded',
        visibility: 'all',
        total: 10000,
        standoutTotal: '10K',
        copy: "You've funded a goliath amount of trees! I mean, we're impressed to say the least. Keep going, keep planting, keep being awesome.",
        category: BadgeCategory.TreesPlanted,
    },
    trees50000: {
        id: 'trees50000',
        title: '50,000 trees funded',
        visibility: 'all',
        total: 50000,
        standoutTotal: '50K',
        copy: "50,000 trees! That's right — just think of the difference you're making to the planet. Keep doing what you're doing, and carry on making a positive impact!",
        category: BadgeCategory.TreesPlanted,
    },
    trees100000: {
        id: 'trees100000',
        title: '100,000 trees funded',
        visibility: 'all',
        total: 100000,
        standoutTotal: '100K',
        copy: "Outstanding! You've funded your 100,000th tree, this an achievement of gargantuan proportions. Let the world know!",
        category: BadgeCategory.TreesPlanted,
    },
    trees250000: {
        id: 'trees250000',
        title: '250,000 trees funded',
        visibility: 'all',
        total: 250000,
        standoutTotal: '250K',
        copy: "You're on a roll! You've funded a quarter of a million trees in forests across the globe. You're well on your way to making a substantial impact for generations to come. Well done!",
        category: BadgeCategory.TreesPlanted,
    },
    trees500000: {
        id: 'trees500000',
        title: '500,000 trees funded',
        visibility: 'all',
        total: 500000,
        standoutTotal: '500K',
        copy: "You're awesome, and you've just funded your 500,000th tree. We really love you for it! Keep up the good work, champ!",
        category: BadgeCategory.TreesPlanted,
    },
    trees750000: {
        id: 'trees750000',
        title: '750,000 trees funded',
        visibility: 'all',
        total: 750000,
        standoutTotal: '750K',
        copy: "We bow down to you, awesome eco-warrior! You've funded 750,000 trees. Just think of the amazing forest you're helping to grow, and all the life it will sustain in the future. Go you!",
        category: BadgeCategory.TreesPlanted,
    },
    trees1000000: {
        id: 'trees1000000',
        title: '1,000,000 trees funded',
        visibility: 'all',
        total: 1000000,
        standoutTotal: '1M',
        copy: "You've done something truly amazing… YOU'VE FUNDED 1,000,000 TREES!",
        category: BadgeCategory.TreesPlanted,
    },
    sparklyTrees25: {
        id: 'sparklyTrees25',
        title: '25 sparkly trees funded',
        visibility: 'all',
        total: 25,
        standoutTotal: '25',
        copy: "Look at them shining! Nice work, you're well on your way to a big ol' sparkly forest.",
        category: BadgeCategory.SparklyTrees,
    },
    sparklyTrees150: {
        id: 'sparklyTrees150',
        title: '150 sparkly trees funded',
        visibility: 'all',
        total: 150,
        standoutTotal: '150',
        copy: "You've got more sparkly trees than you can shake a stick at.",
        category: BadgeCategory.SparklyTrees,
    },
    sparklyTrees300: {
        id: 'sparklyTrees300',
        title: '300 sparkly trees funded',
        visibility: 'all',
        total: 300,
        standoutTotal: '300',
        copy: 'By this point your forest is brighter than the sun!',
        category: BadgeCategory.SparklyTrees,
    },
    sparklyTrees500: {
        id: 'sparklyTrees500',
        title: '500 sparkly trees funded',
        visibility: 'all',
        total: 500,
        standoutTotal: '500',
        copy: "Cor blimey, you've got 500 sparkly trees in your forest. Amazing work, keep it up!",
        category: BadgeCategory.SparklyTrees,
    },
    climatePositiveMonths3: {
        id: 'climatePositiveMonths3',
        title: '3 months of climate action',
        visibility: 'all',
        total: 3,
        standoutTotal: '3',
        copy: "Well lookie here, you've achieved 3 months of climate impact! Give yourself a big high five.",
        category: BadgeCategory.ClimatePositive,
    },
    climatePositiveMonths6: {
        id: 'climatePositiveMonths6',
        title: '6 months of climate action',
        visibility: 'all',
        total: 6,
        standoutTotal: '6',
        copy: "Gosh would you look at that, you've ticked off 6 whole months of climate impact.",
        category: BadgeCategory.ClimatePositive,
    },
    climatePositiveMonths12: {
        id: 'climatePositiveMonths12',
        title: '1 year of climate action',
        visibility: 'all',
        total: 12,
        standoutTotal: '12',
        copy: 'What a difference a year makes. Seriously, 12 months is a big deal so take a moment to sit back and soak it up.',
        category: BadgeCategory.ClimatePositive,
    },
    climatePositiveMonths24: {
        id: 'climatePositiveMonths24',
        title: '2 years of climate action',
        visibility: 'all',
        total: 24,
        standoutTotal: '24',
        copy: "You're starting to make this look easy! Keep the amazing work, the planet needs more folks like you.",
        category: BadgeCategory.ClimatePositive,
    },
    climatePositiveMonths36: {
        id: 'climatePositiveMonths36',
        title: '3 years of climate action',
        visibility: 'all',
        total: 36,
        standoutTotal: '36',
        copy: "You're the ultimate climate crisis fighting machine! Congratulations, you're charging ahead and doing your bit for the planet.",
        category: BadgeCategory.ClimatePositive,
    },
    leaderboardTop50Member: {
        id: 'leaderboardTop50Member',
        title: 'Top 50 member tree leaderboard',
        visibility: 'member-only',
        total: 0,
        standoutTotal: 'Top 50',
        copy: "Look at your speeding ahead! You've made it into our top 50 members leaderboard. Go on shout it from the rooftops.",
        category: BadgeCategory.Leaderboard,
    },
    leaderboardTop10Member: {
        id: 'leaderboardTop10Member',
        title: 'Top 10 member tree leaderboard',
        visibility: 'member-only',
        total: 0,
        standoutTotal: 'Top 10',
        copy: "You're the ultimate tree funding machine! You're in the top 10 of our members leaderboard.",
        category: BadgeCategory.Leaderboard,
    },
    leaderboardNumber1Member: {
        id: 'leaderboardNumber1Member',
        title: 'Top of the member tree leaderboard',
        visibility: 'member-only',
        total: 0,
        standoutTotal: '#1',
        copy: "You're the greenest of the green! Amazing work my friend, you're at the top of our members leaderboard.",
        category: BadgeCategory.Leaderboard,
    },
    leaderboardTop50Business: {
        id: 'leaderboardTop50Business',
        title: 'Top 50 business tree leaderboard',
        visibility: 'business-only',
        total: 0,
        standoutTotal: 'Top 50',
        copy: 'Pop a bottle because you and your company have made it into our top 50 business leaderboard. This is a huge achievement, make sure to share it with your team.',
        category: BadgeCategory.Leaderboard,
    },
    leaderboardTop10Business: {
        id: 'leaderboardTop10Business',
        title: 'Top 10 business tree leaderboard',
        visibility: 'business-only',
        total: 0,
        standoutTotal: 'Top 10',
        copy: "A round of applause because your business is now in the top 10 business leaderboard. This is a huge achievement so why not share it with your team, I bet they'll be over the moon.",
        category: BadgeCategory.Leaderboard,
    },
    leaderboardNumber1Business: {
        id: 'leaderboardNumber1Business',
        title: 'Top of the business tree leaderboard',
        visibility: 'business-only',
        total: 0,
        standoutTotal: '#1',
        copy: "You saw the challenge of being a climate positive workplace and you rose to that challenge. You're now at the top of our business leaderboard!",
        category: BadgeCategory.Leaderboard,
    },
    leaderboardTop50Sparkly: {
        id: 'leaderboardTop50Sparkly',
        title: 'Top 50 sparkly tree leaderboard',
        visibility: 'all',
        total: 0,
        standoutTotal: 'Top 50',
        copy: "You're the shiniest of the shiny! You've made it into our top 50 sparkly tree leaderboard, so here a new shiny badge to match it.",
        category: BadgeCategory.Leaderboard,
    },
    leaderboardTop10Sparkly: {
        id: 'leaderboardTop10Sparkly',
        title: 'Top 10 sparkly tree leaderboard',
        visibility: 'all',
        total: 0,
        standoutTotal: 'Top 10',
        copy: "You're the sparkliest of the sparkly! Congratulations, you've made it into our top 10 sparkly leaderboard.",
        category: BadgeCategory.Leaderboard,
    },
    leaderboardNumber1Sparkly: {
        id: 'leaderboardNumber1Sparkly',
        title: 'Top of the sparkly tree leaderboard',
        visibility: 'all',
        total: 0,
        standoutTotal: '#1',
        copy: "You're the sparkliest of us all! Nice work you're now at the top of our sparkly tree leaderboard.",
        category: BadgeCategory.Leaderboard,
    },
    offsetTonnes10: {
        id: 'offsetTonnes10',
        title: '10 tonnes of CO2e avoided',
        visibility: 'all',
        total: 10,
        standoutTotal: '10',
        copy: "Look at that, you've avoided 10 tonnes of CO2e in our atmosphere. That's the equivalent of not charging your phone 1,275,322 times.",
        category: BadgeCategory.CarbonReduction,
    },
    offsetTonnes50: {
        id: 'offsetTonnes50',
        title: '50 tonnes of CO2e avoided',
        visibility: 'all',
        total: 50,
        standoutTotal: '50',
        copy: "Woah there, that's 50 tonnes of CO2e you've prevented from entering the atmosphere. That's the same amount of carbon that would be produced by 4,912 gallons of diesel.",
        category: BadgeCategory.CarbonReduction,
    },
    offsetTonnes100: {
        id: 'offsetTonnes100',
        title: '100 tonnes of CO2e avoided',
        visibility: 'all',
        total: 100,
        standoutTotal: '100',
        copy: "Amazing! You've avoided 100 tonnes of CO2e in our planet's atmosphere. This amount of carbon is equivalent to 248,139 miles driven in a car. Crazy right?",
        category: BadgeCategory.CarbonReduction,
    },
    offsetTonnes1000: {
        id: 'offsetTonnes1000',
        title: '1,000 tonnes of CO2e avoided',
        visibility: 'all',
        total: 1000,
        standoutTotal: '1K',
        copy: "Golly gosh, you've avoided 1,000 tonnes of CO2e running rampant in our Earth's atmosphere. That's the equivalent of over 600 flights from London to New York! Keep up the incredible work.",
        category: BadgeCategory.CarbonReduction,
    },
};
const getValues = (obj) => {
    const keys = Object.keys(obj);
    return keys.map((k) => obj[k]);
};
exports.climatePositiveBadges = getValues(exports.availableBadges).filter((b) => b.category === 'climate-positive');
exports.treeBadges = getValues(exports.availableBadges).filter((b) => b.category === 'trees-planted');
exports.sparklyBadges = getValues(exports.availableBadges).filter((b) => b.category === 'sparkly-trees');
exports.carbonReductionBadges = getValues(exports.availableBadges).filter((b) => b.category === 'carbon-reduction');
exports.leaderboardBadges = getValues(exports.availableBadges).filter((b) => b.category === BadgeCategory.Leaderboard);
exports.mtpBadge = exports.availableBadges.mtpBadge;
exports.sparklyLeaderboardIds = [
    'leaderboardNumber1Sparkly',
    'leaderboardTop10Sparkly',
    'leaderboardTop50Sparkly',
    'leaderboardTop100Sparkly',
];
exports.memberLeaderboardIds = [
    'leaderboardNumber1Member',
    'leaderboardTop10Member',
    'leaderboardTop50Member',
    'leaderboardTop100Member',
];
exports.businessLeaderboardIds = [
    'leaderboardNumber1Business',
    'leaderboardTop10Business',
    'leaderboardTop50Business',
    'leaderboardTop100Business',
];
//# sourceMappingURL=data:application/json;base64,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